<template>
  <div v-if="isAdmin || isSectorManager">
    <div class="columns is-gapless has-bg-white is-min-height-50 is-border-top">
      <div class="column is-self-centered is-padding-left">
        <div class="is-uppercase is-size-6">Vendeur {{i + 1}}</div>
      </div>
      <div class="column is-narrow is-min-height-full">
        <button class="button is-success is-radiusless is-small is-min-height-full" @click="sellerFacturation(selectedShare)">
          <!-- <span>Gérer {{isNil(selectedShare.company) ? 'acompte et bonus' : 'facturation' }}</span> -->
          <span v-if="selectedShare.company">Gérer facturation</span>
          <span v-else>Gérer bonus</span>
        </button>
      </div>
      <div v-if="i > 0 && !cantEditCom && !share.terminated && (isAdmin || isSectorManager)" class="column is-narrow is-border-left">
        <a class="column is-narrow has-bg-white is-flex is-padding-small tooltip is-tooltip-top"
            @click="removeSellerShare(selectedShare)"  data-tooltip="Supprimer le vendeur">
          <span class="icon has-text-grey is-size-4"><i class="fal fa-trash-alt"></i></span>
        </a>
      </div>
    </div>

    <div class="is-border-top is-padding-left is-padding-bottom  is-padding-right is-padding-top-small columns is-gapless has-bg-lighter">
      <div class="column is-5 columns is-gapless is-vcentered is-multiline has-text-primary">
        <div class="column is-12 is-size-7 is-margin-bottom-xxsmall is-uppercase">&nbsp;</div>
        <div class="column is-narrow is-margin-right">
          <avatar :item="selectedShare" :i="i" :classes="'has-bg-reserve'"></avatar>
        </div>
        <div class="column">
          <b>{{selectedShare.seller_name}}</b>
          <br v-if="selectedShare.company">
          <span v-if="share.company">Société {{selectedShare.company_name}}</span>
        </div>
      </div>
      <div class="column is-4 columns is-gapless is-column is-margin-left has-text-primary">
        <div>
          <div class="is-size-7 is-margin-bottom-xxsmall is-uppercase">Taux de commission</div>
          <div v-if="isAdmin || isSectorManager" class="field has-addons">
            <v-input :id="`input${selectedShare.seller}`"
              :name="`input${selectedShare.seller}`"
              @input="val => updateSellerRemuneration(val)"
              @focus="selectInput(`input${selectedShare.seller}`)"
              :model="selectedShare.remuneration"
              :errors-bag="errors"
              data-vv-value-path="val"
              classes="has-text-centered w90p"
              :max="100" :number="true"
              input-type="number"
              data-vv-as=" "
              icon="fa-percentage"
              v-validate="''"
              :hasIncrementations="true"
              :incrementationsPas="0.1">
              <div class="control">
                <a class="button is-static is-border is-square">
                  <span class="icon"><i class="fas fa-percentage"></i></span>
                </a>
              </div>
              <div class="control" v-if="displayNewTauxComButton">
                <a @click="updateSellerShare(selectedShare)" 
                  class="button is-success is-square tooltip is-tooltip-right"
                  data-tooltip="Valider la modification du taux">
                  <span class="icon"><i class="fas fa-save"></i></span>
                </a>
              </div>
              <div class="control" v-if="displayNewTauxComButton">
                <a @click="editTauxCom(selectedShare)" data-tooltip="Annuler la modification du taux" 
                  class="button tooltip is-tooltip-right is-square is-draft">
                  <span class="icon has-text-white"><i class="fas fa-times"></i></span>
                </a>
              </div>
            </v-input>
          </div>
          <div v-else class="field is-grouped adv-hero-inputDark">
            <div class="">{{ selectedShare.remuneration }} %</div>
          </div>
        </div>
      </div>
      <div class="column has-text-right has-text-primary">
        <div class="is-size-7 is-margin-bottom-xxsmall is-uppercase">&nbsp;</div>
        <div class="has-text-weight-bold">{{Number(selectedShare.total_rem_ht).toFixed(2)}} {{$currency}} HT</div>
        <div>{{Number(selectedShare.total_rem_ttc).toFixed(2)}} {{$currency}} TTC</div>
      </div>
    </div>

    <div v-if="selectedShare.bonuses.length > 0 || selectedShare.deposits.length > 0 || share.terminated"
          class="has-bg-light is-padding is-border-top columns is-gapless">
      <div class="columns is-5 is-uppercase has-text-primary">
        <div class="column is-paddingless is-narrow is-margin-right"><span class="avatar avatar-03"><span class="has-bg-reserve"></span></span></div>
        <div class="column is-paddingless">
          <span v-for="(deposit, idx) in selectedShare.deposits" :key="`${idx}-deposit`">
            Acompte <span v-if="deposit.unit === 'percent'">{{deposit.amount}}% </span> : <span class="has-text-weight-medium"> {{deposit.total_ht.toFixed(2)}} {{$currency}} HT</span>
            <br>
          </span>
          <span v-for="(bonus, idx) in selectedShare.bonuses" :key="`${idx}-bonus`">
            Bonus <span v-if="bonus.unit === 'percent'">{{bonus.amount}}% </span>: <span class="has-text-weight-medium">{{bonus.total_ht.toFixed(2) }} {{$currency}} HT </span>
            <br>
          </span>
        </div>
      </div>
      <div class="column has-text-right">
        <div v-for="(deposit, idx) in selectedShare.deposits" :key="`${idx}-deposit-facture`" v-if="deposit.terminated" class="is-size-6 has-text-primary">
          Facture acompte finalisée
          <span v-if="deposit.sending_date"> le {{deposit.sending_date | dtFormat('DD/MM/YYYY')}}</span>
        </div>
        <div v-if="share.terminated" class="is-size-6 has-text-primary">
          Facture solde finalisée
          <span v-if="share.balance_billing_date"> le {{share.balance_billing_date | dtFormat('DD/MM/YYYY')}}</span>
        </div>
      </div>
      
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { isNil, clone } from 'lodash'

  export default {
    name: 'SellerShare',
    data () {
      return {
        displayNewTauxComButton: false,
        editShare: false,
        isNil,
        savedTauxCom: null
      }
    },
    props: {
      share: Object,
      i: Number
    },
    watch: {
      share () {
        this.editShare = false
      }
    },
    computed: {
      ...mapGetters(['isAdmin', 'isSectorManager', 'currentUserPk']),
      selectedShare () {
        return Object.assign({}, this.share)
      },
      cantEditCom () {
        if (this.selectedShare && this.selectedShare.deposits) {
          let deposits = this.selectedShare.deposits.reduce((a, b) => {
            return b.terminated ? a + 1 : a
          }, 0)
          return !!deposits
        }
      }
    },
    methods: {
      editTauxCom (share) {
        this.selectedShare.remuneration = clone(this.savedTauxCom)
        this.$emit('updateSellerShare', this.selectedShare)
      },
      sellerFacturation (share) {
        this.$emit('sellerFacturation', share)
      },
      removeSellerShare (share) {
        this.$emit('removeSellerShare', share)
      },
      selectInput (input) {
        if (input in this.$refs) {
          if (Array.isArray(this.$refs[input])) {
            this.$refs[input][0].select()
          } else {
            this.$refs[input].select()
          }
        }
      },
      updateSellerRemuneration (val) {
        this.savedTauxCom = clone(this.selectedShare.remuneration)
        this.displayNewTauxComButton = true
        this.editShare = true
        this.$nextTick(() => {
          this.selectedShare.remuneration = val
        })
      },
      updateSellerShare (share) {
        if (share.terminated) {
          this.$notify({
            type: 'is-danger',
            text: 'Modification du taux impossible car facture finalisée'
          })
        } else {
          this.editShare = false
          this.$emit('updateSellerShare', share)
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/adv/Commercialisation/SellerShare.vue